import { ToggleButton, ToggleButtonGroup } from '@mui/material';

interface Props {
  directory: boolean;
  onChange: (directory: boolean) => void;
}

export function PerformerScope({ directory, onChange }: Props) {
  return (
    <ToggleButtonGroup
      exclusive
      value={directory}
      aria-label="Performer list scope"
      onChange={(_, value: boolean | null) => {
        if (value !== null) onChange(value);
      }}
      sx={{ mb: 2, flexWrap: 'wrap' }}
    >
      <ToggleButton value={false}>Your team's performers</ToggleButton>
      <ToggleButton value={true}>Shared directory</ToggleButton>
    </ToggleButtonGroup>
  );
}
